import { useMemo, useState } from "react";
import { useSite } from "../lib/SiteContext";
import Seo from "../components/Seo";
import FadeIn from "../components/FadeIn";
import TourCard from "../components/TourCard";

const Tours = () => {
  const { tours } = useSite();
  const [category, setCategory] = useState("All");

  const categories = useMemo(() => ["All", ...new Set(tours.map((t) => t.category))], [tours]);
  const filtered = category === "All" ? tours : tours.filter((t) => t.category === category);

  return (
    <div data-testid="tours-page">
      <Seo
        title="All Private Tours in Corfu — Aloha Corfu Tours"
        description="Browse all private Corfu tours: Paleokastritsa, Corfu Old Town, Canal d'Amour, Porto Timoni, Kassiopi, villages, tastings and fully customizable island tours. Prices on request."
      />
      <section className="bg-pine-dark py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-seafoam">Sightseeing & experiences</p>
            <h1 className="mt-2 font-display text-4xl font-semibold text-white sm:text-5xl">All Tours in Corfu</h1>
            <p className="mt-4 max-w-2xl text-base text-white/75">
              Every tour is fully private — your group, your pace, with pickup from your hotel, villa or the port.
              Prices are provided on request, tailored to your group.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-8 flex flex-wrap gap-2" data-testid="tour-category-filters">
            {categories.map((c) => (
              <button
                key={c}
                onClick={() => setCategory(c)}
                data-testid={`filter-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors duration-200 ${
                  category === c ? "bg-pine text-white" : "bg-seafoam-light text-pine hover:bg-seafoam/40"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8" data-testid="tours-grid">
            {filtered.map((tour, i) => (
              <FadeIn key={tour.id} delay={Math.min(i, 5) * 0.06}><TourCard tour={tour} /></FadeIn>
            ))}
          </div>
          {filtered.length === 0 && (
            <p className="py-16 text-center text-gray-500" data-testid="tours-empty">No tours in this category yet.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Tours;
